import { useEffect, useState } from 'react';
import { useAxios } from '../../utils/hook/useAxios';

/* ---------- Données d'affichage ---------- */

const RESERVATION_TYPES = [
  { value: '0', label: 'Sur réservation', id: 'flexRadioDefault1' },
  { value: '1', label: 'MOOViCar Connect', id: 'flexRadioDefault2' },
];

const SWITCHES = [
  { id: 'flexSwitchCheckDefault', label: 'Distance minimum incluse' },
  { id: 'flexSwitchCheckDefault2', label: 'Conducteur inclus' },
  { id: 'flexSwitchCheckDefault3', label: 'Carburant inclus' },
  { id: 'flexSwitchCheckDefault4', label: "Délai d'annulation de réservation" },
  { id: 'flexSwitchCheckDefault5', label: 'Supplément pour conducteur jeune' },
];

const CANCEL_POLICIES = [
  {
    value: 'flexible',
    label: 'Flexible',
    desc: '100% remboursé si annulation >24h avant, 50% sinon',
  },
  {
    value: 'moderate',
    label: 'Modérée',
    desc: '100% si >5 jours avant, 50% si 1–5 jours, 0% sinon',
  },
  {
    value: 'strict',
    label: 'Stricte',
    desc: '100% si >14 jours avant, non remboursable sinon',
  },
];

/* ---------- Petits composants de présentation ---------- */

function BlockTitle({ icon, children }) {
  return (
    <h3 className="mc-form-section-title mc-block-title">
      <ion-icon name={icon}></ion-icon>
      {children}
    </h3>
  );
}

function Switch({ id, label, checked, onChange }) {
  return (
    <label className="mc-switch" htmlFor={id}>
      <input type="checkbox" role="switch" id={id} checked={checked} onChange={onChange} />
      <span className="mc-switch-text">{label}</span>
      <span className="mc-switch-track" aria-hidden="true"></span>
    </label>
  );
}

function OptionCard({ type = 'radio', name, id, value, checked, onChange, label, desc }) {
  return (
    <label className="mc-policy" htmlFor={id}>
      <input type={type} name={name} id={id} value={value} checked={checked} onChange={onChange} />
      <span className="mc-policy-body">
        <strong>{label}</strong>
        {desc && <small>{desc}</small>}
      </span>
    </label>
  );
}

function TimeRange({ startValue, endValue, onStart, onEnd }) {
  return (
    <div className="mc-grid-2 mc-grid-2--tight">
      <div>
        <label className="mc-field-label">Ouverture</label>
        <input
          type="time"
          className="mc-input"
          value={startValue}
          onChange={(e) => onStart(e.target.value)}
        />
      </div>
      <div>
        <label className="mc-field-label">Fermeture</label>
        <input
          type="time"
          className="mc-input"
          value={endValue}
          onChange={(e) => onEnd(e.target.value)}
        />
      </div>
    </div>
  );
}

/* ---------- Composant ---------- */

function AnnonceVehiculeModal({ vehicule }) {
  const [reservationPrice, setReservationPrice] = useState(0);
  const [reservationType, setReservationType] = useState(null);
  const [reservationDistanceMin, setReservationDistanceMin] = useState(0);
  const [distanceMin, setDistanceMin] = useState(false);
  const [pickupTimeStart, setPickupTimeStart] = useState('08:00');
  const [pickupTimeEnd, setPickupTimeEnd] = useState('20:00');
  const [returnTimeStart, setReturnTimeStart] = useState('08:00');
  const [returnTimeEnd, setReturnTimeEnd] = useState('20:00');
  const [annulationPolicy, setAnnulationPolicy] = useState('moderate');

  const axios = useAxios();

  const [checkboxValues, setCheckboxValues] = useState({
    flexSwitchCheckDefault: 0,
    flexSwitchCheckDefault2: 0,
    flexSwitchCheckDefault3: 0,
    flexSwitchCheckDefault4: 0,
    flexSwitchCheckDefault5: 0,
  });

  // Gestionnaire de changement pour mettre à jour l'état des cases à cocher

  // Fonctions de rappel pour récupérer les valeurs sélectionnées
  useEffect(() => {
    let fetchReviews = async () => {};
    fetchReviews();
  }, []);
  const handleReservationTypeChange = (event) => {
    setReservationType(event.target.value);
  };

  const handleReservationPriceChange = (event) => {
    setReservationPrice(event.target.value);
  };

  const handleReservationDistanceMinChange = (event) => {
    setReservationDistanceMin(event.target.value);
  };

  const handleCheckboxChange = (id, value) => {
    setCheckboxValues((prevValues) => ({
      ...prevValues,
      [id]: value,
    }));

    if (checkboxValues['flexSwitchCheckDefault'] == '1') setDistanceMin(false);
    else setDistanceMin(true);
  };

  function handleSave() {
    axios
      .post('/vehicleAnnonces', {
        Annonce: {
          reservationPrice: reservationPrice,
          distanceOutMin: reservationDistanceMin,
          locationMode: reservationType,
          vehiculeId: vehicule.id,
          minDistanceInclus: checkboxValues['flexSwitchCheckDefault'].toString(),
          additionalDriverInclus: checkboxValues['flexSwitchCheckDefault2'].toString(),
          annulationAnnonceDelayBefore: checkboxValues['flexSwitchCheckDefault4'].toString(),
          carburantInclus: checkboxValues['flexSwitchCheckDefault3'].toString(),
          supplementJeuneDriver: checkboxValues['flexSwitchCheckDefault5'].toString(),
          locationAddress: vehicule.CoordonatesCity,
          locationCoordinates: vehicule.CoordonatesCity,
          status: '0',
          pickupTimeStart,
          pickupTimeEnd,
          returnTimeStart,
          returnTimeEnd,
          annulationPolicy,
        },
        EmailData: {
          nom: 'Fatah',
          prenom: 'Ahmed',
          Linkurl: 'https://trustdataverify.com',
          email: 'fatahouahamadi88@gmail.com',
        },
      })
      .then((response) => {
        // Réussite de la requête
        console.log('Réponse du serveur:', response.data);
        window.location.href =
          '/emplacement-delivery-car/' +
          vehicule.id +
          '/annonce/' +
          response.data.vehiculeAnnonceId;
      })
      .catch((error) => {
        // Erreur lors de la requête
        console.error('Erreur de requête:', error);
      });
  }

  return (
    <div className="mc-annonce-form">
      <div className="mc-form-alert mc-form-alert--info mc-form-alert--flush" role="note">
        <ion-icon name="bulb-outline"></ion-icon>
        <span>
          Nous vous recommandons de fixer un prix de 30 € pour obtenir plus de réservations.
        </span>
      </div>

      {/* --- Tarif --- */}
      <div className="mc-form-block">
        <BlockTitle icon="pricetag-outline">Tarif</BlockTitle>
        <label className="mc-field-label" htmlFor="reservationPrice">
          Prix de réservation
        </label>
        <div className="mc-input-affix">
          <input
            type="text"
            inputMode="decimal"
            className="mc-input"
            id="reservationPrice"
            placeholder="450"
            value={reservationPrice}
            onChange={handleReservationPriceChange}
          />
          <span>€</span>
        </div>
      </div>

      {/* --- Mode de location --- */}
      <div className="mc-form-block">
        <BlockTitle icon="key-outline">Mode de location</BlockTitle>
        <div className="mc-option-grid">
          {RESERVATION_TYPES.map(({ value, label, id }) => (
            <OptionCard
              key={id}
              name="flexRadioDefault"
              id={id}
              value={value}
              checked={reservationType === value}
              onChange={handleReservationTypeChange}
              label={label}
            />
          ))}
        </div>
      </div>

      {/* --- Conditions incluses --- */}
      <div className="mc-form-block">
        <BlockTitle icon="options-outline">Conditions</BlockTitle>
        <div className="mc-switch-list">
          {SWITCHES.map(({ id, label }) => (
            <Switch
              key={id}
              id={id}
              label={label}
              checked={checkboxValues[id] === 1}
              onChange={(e) => handleCheckboxChange(id, e.target.checked ? 1 : 0)}
            />
          ))}
        </div>

        <div className="mc-field">
          <label className="mc-field-label" htmlFor="distanceMin">
            Distance minimum
          </label>
          <div className="mc-input-affix">
            <input
              type="text"
              inputMode="numeric"
              className="mc-input"
              id="distanceMin"
              placeholder="300"
              value={reservationDistanceMin}
              onChange={handleReservationDistanceMinChange}
              disabled={!distanceMin}
            />
            <span>km</span>
          </div>
        </div>
      </div>

      {/* --- Horaires --- */}
      <div className="mc-form-block">
        <BlockTitle icon="time-outline">Heures de prise en charge</BlockTitle>
        <TimeRange
          startValue={pickupTimeStart}
          endValue={pickupTimeEnd}
          onStart={setPickupTimeStart}
          onEnd={setPickupTimeEnd}
        />
      </div>

      <div className="mc-form-block">
        <BlockTitle icon="return-down-back-outline">Heures de retour</BlockTitle>
        <TimeRange
          startValue={returnTimeStart}
          endValue={returnTimeEnd}
          onStart={setReturnTimeStart}
          onEnd={setReturnTimeEnd}
        />
      </div>

      {/* --- Politique d'annulation --- */}
      <div className="mc-form-block">
        <BlockTitle icon="shield-checkmark-outline">Politique d'annulation</BlockTitle>
        <div className="mc-policy-list">
          {CANCEL_POLICIES.map(({ value, label, desc }) => (
            <OptionCard
              key={value}
              name="policy"
              id={`policy-${value}`}
              value={value}
              checked={annulationPolicy === value}
              onChange={() => setAnnulationPolicy(value)}
              label={label}
              desc={desc}
            />
          ))}
        </div>
      </div>

      <div className="mc-form-actions">
        <button type="button" className="mc-btn mc-btn--primary mc-btn--block" onClick={handleSave}>
          Enregistrer l'annonce
          <ion-icon name="arrow-forward-outline"></ion-icon>
        </button>
      </div>
    </div>
  );
}

export default AnnonceVehiculeModal;
